"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoadingButtonMixin = require("../../mixins/components/LoadingButtonMixin");
var _LoadingMask = require("../LoadingMask/LoadingMask");
var StyledLoadingButton = /*#__PURE__*/(0, _styledComponents.default)(_LoadingMask.LoadingMask).withConfig({
  displayName: "StyledLoadingButton",
  componentId: "c11n-8-107-0__sc-2wv8o1-0"
})(["", ""], _LoadingButtonMixin.LoadingButtonMixin);
exports.StyledLoadingButton = StyledLoadingButton;